import { Alert, Stack } from "@mui/material";

import type { ClientCdpRetailChannel } from "../../../../lib/api/types";
import Client360ChannelFieldGrid from "./Client360ChannelFieldGrid";

function display(value: string | number | null | undefined, suffix = "") {
    if (value === null || value === undefined || value === "") {
        return "—";
    }

    return `${value}${suffix}`;
}

export default function Client360RetailChannelTab({ channel }: { channel: ClientCdpRetailChannel }) {
    if (!channel.hasData) {
        return <Alert severity="info">Няма данни за магазинен (retail) канал при този клиент.</Alert>;
    }

    return (
        <Stack spacing={2}>
            <Client360ChannelFieldGrid
                title="Магазин — Червена карта"
                subtitle=""
                rows={[
                    { label: "Номер на карта", value: display(channel.cardNumber) },
                    { label: "Статус на карта", value: display(channel.cardStatus) },
                    { label: "Магазин / район", value: display(channel.registrationStore) },
                    { label: "Дата на издаване", value: display(channel.issuedAt) },
                    { label: "Име", value: display(channel.holderName) },
                    { label: "Телефон", value: display(channel.phone) },
                    { label: "Имейл", value: display(channel.email) },
                    { label: "Квартал", value: display(channel.district) },
                    { label: "Ниво лоялност", value: display(channel.loyaltyTier) },
                    { label: "Натрупан оборот", value: display(channel.accumulatedTurnover?.toLocaleString("bg-BG"), " €") },
                    { label: "Предпочитан магазин", value: display(channel.preferredStore) },
                ]}
            />
        </Stack>
    );
}
